module.exports = __webpack_public_path__ + "img/Primordial-Process-3-mobile.a1c04d89.png";